import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
export default function NaverCallbackPage() {
  const [params] = useSearchParams()
  const { login } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const token = params.get('token')
    if (!token) {
      window.history.replaceState({}, '', '/')
      navigate('/login')
      return
    }
    window.history.replaceState({}, '', '/')
    const email = params.get('email') ?? ''
    const name = params.get('name') ?? ''
    const raw = params.get('userLevel')
    const userLevel = raw === 'STANDARD' || raw === 'PROFESSIONAL' ? raw : 'FREE'
    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      login(token, { userId: payload.sub, name: name || payload.sub, email, userLevel })
    } catch {
      login(token, { userId: 'naver_user', name: name || '네이버 사용자', email, userLevel })
    }
    navigate('/dashboard')
  }, [params, login, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-gray-600">로그인 처리 중...</p>
    </div>
  )
}
